export const G2ReviewUrl = "https://www.g2.com/products/ppm-express/reviews";
export const G2RatingSchemaUrl = "https://www.g2.com/products/ppm-express/rating_schema.json";